import { useCallback } from 'react';

import type { ProjectsFilter, ProjectsResponse } from '../../../../../../shared/projectsV2';
import { useAsyncRequest } from '../../../../../hooks';
import { get } from '../../../../../redux/api';
import type { ReleaseGroupProjectSort } from '../shared/types';

const fetchProjects = async (filters: ProjectsFilter, sort: ReleaseGroupProjectSort, page: number, count: number) => {
  return get<ProjectsResponse>('/api/v2/projects', false, {
    ...filters,
    sort,
    page,
    count,
  });
};

/**
 * useProjects is a hook that fetches and returns projects from the ProjectsV2 API.
 * It will automatically re-fetch the projects when the filters or sort change.
 */
function useProjects(filters: ProjectsFilter, sort: ReleaseGroupProjectSort, page: number, count: number) {
  const onFetchProjects = useCallback(() => fetchProjects(filters, sort, page, count), [filters, sort, page, count]);
  const projectsAsyncValue = useAsyncRequest(onFetchProjects);
  const projectsResponse: ProjectsResponse = projectsAsyncValue.value ?? {
    projects: [],
    total: 0,
  };

  return {
    isLoading: projectsAsyncValue.isLoading,
    projects: projectsResponse.projects,
    projectCount: projectsResponse.total,
    projectErrors: projectsAsyncValue.errors,
  };
}

export default useProjects;
